import { Component } from 'react';
import CancelationModal from './CancelationModal';
import ConfirmationModal from '../../../../components/Modals/ConfirmationModal';

class CancelationByUnselectAll extends Component {
    constructor(props) {
        super(props);

        this.onOpenModal = this.onOpenModal.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);

        this.state = {
            isOpenModal: false,
        };
    }

    onOpenModal() {
        this.props.onClose();
        this.setState({ isOpenModal: true });
    }

    onCloseModal() {
        this.setState({ isOpenModal: false });
    }

    render() {
        return (
            <>
                <ConfirmationModal
                    isOpen={this.props.isOpen}
                    message={
                        'You have removed all products from your subscription, are you sure you want to cancel?'
                    }
                    cancleBtn={"No, Don't Cancel"}
                    onClose={this.props.onClose}
                    onSubmit={this.onOpenModal}
                    buttonName={'Yes, Cancel my Subscription'}
                />
                <CancelationModal
                    isOpenModal={this.state.isOpenModal}
                    onCloseModal={this.onCloseModal}
                />
            </>
        );
    }
}

export default CancelationByUnselectAll;
